import React, { useState, useEffect } from 'react';
import styles from './NavbarSimple.module.css';

const Navbar = ({ navigateTo, currentPage }) => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    if (currentPage !== 'home') {
      // Si on n'est pas sur la page d'accueil, on y retourne d'abord
      navigateTo('home');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 100);
    } else {
      // Si on est sur la page d'accueil, on fait juste le scroll
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
    setIsNavOpen(false);
  };

  const handleNavigation = (page) => {
    navigateTo(page);
    setIsNavOpen(false);
  };

  return (
    <header className={`${styles.navbar} ${isScrolled ? styles.scrolled : ''}`}>
      <div className="container-fluid px-4">
        <div className="d-flex justify-content-between align-items-center">
          {/* Logo */}
          <div
            className={styles.navbarBrand}
            onClick={() => navigateTo('home')}
            style={{ cursor: 'pointer' }}
          >
            <div className={styles.logoContainer}>
              <img
                src="/images/logo-dhr-nobackrgound.png"
                alt="DHR Structures"
                className={styles.logoImage}
              />
            </div>
            <div className={styles.brandText}>
              <h2>DHR Structures</h2>
              <span className={styles.tagline}>Ingéniosité - Maîtrise – Performance</span>
            </div>
          </div>

          {/* Navigation */}
          <nav className="d-flex align-items-center" aria-label="Navigation principale">
            {/* Hamburger */}
            <button
              className={styles.navbarToggler}
              onClick={() => setIsNavOpen(!isNavOpen)}
            >
              <div className={`${styles.hamburgerLine} ${isNavOpen ? styles.line1 : ''}`}></div>
              <div className={`${styles.hamburgerLine} ${isNavOpen ? styles.line2 : ''}`}></div>
              <div className={`${styles.hamburgerLine} ${isNavOpen ? styles.line3 : ''}`}></div>
            </button>

            {/* Menu horizontal */}
            <div className={styles.navbarNav}>
              <button
                onClick={() => scrollToSection('home')}
                className={`${styles.navLink} ${currentPage === 'home' ? styles.active : ''}`}
              >
                <i className="bi bi-house-door"></i>
                <span>Accueil</span>
              </button>
              <button
                onClick={() => handleNavigation('services')}
                className={`${styles.navLink} ${currentPage === 'services' ? styles.active : ''}`}
              >
                <i className="bi bi-gear"></i>
                <span>Services</span>
              </button>
              <button
                onClick={() => handleNavigation('team')}
                className={`${styles.navLink} ${currentPage === 'team' ? styles.active : ''}`}
              >
                <i className="bi bi-people"></i>
                <span>Équipe</span>
              </button>
              <button
                onClick={() => handleNavigation('projects')}
                className={`${styles.navLink} ${currentPage === 'projects' ? styles.active : ''}`}
              >
                <i className="bi bi-briefcase"></i>
                <span>Projets</span>
              </button>
              <button
                onClick={() => handleNavigation('contact')}
                className={`${styles.navLink} ${currentPage === 'contact' ? styles.active : ''}`}
              >
                <i className="bi bi-envelope"></i>
                <span>Contact</span>
              </button>
            </div>
          </nav>

          {/* Navigation mobile */}
          {isNavOpen && (
            <div className={styles.mobileNav}>
              <div className={styles.mobileNavItem}>
                <button
                  onClick={() => scrollToSection('home')}
                  className={`${styles.mobileNavLink} ${currentPage === 'home' ? styles.active : ''}`}
                >
                  <i className="bi bi-house-door"></i>
                  <span>Accueil</span>
                </button>
              </div>
              <div className={styles.mobileNavItem}>
                <button
                  onClick={() => handleNavigation('services')}
                  className={`${styles.mobileNavLink} ${currentPage === 'services' ? styles.active : ''}`}
                >
                  <i className="bi bi-gear"></i>
                  <span>Services</span>
                </button>
              </div>
              <div className={styles.mobileNavItem}>
                <button
                  onClick={() => handleNavigation('team')}
                  className={`${styles.mobileNavLink} ${currentPage === 'team' ? styles.active : ''}`}
                >
                  <i className="bi bi-people"></i>
                  <span>Équipe</span>
                </button>
              </div>
              <div className={styles.mobileNavItem}>
                <button
                  onClick={() => handleNavigation('projects')}
                  className={`${styles.mobileNavLink} ${currentPage === 'projects' ? styles.active : ''}`}
                >
                  <i className="bi bi-briefcase"></i>
                  <span>Projets</span>
                </button>
              </div>
              <div className={styles.mobileNavItem}>
                <button
                  onClick={() => handleNavigation('contact')}
                  className={`${styles.mobileNavLink} ${currentPage === 'contact' ? styles.active : ''}`}
                >
                  <i className="bi bi-envelope"></i>
                  <span>Contact</span>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Navbar;